import {
  IStyledSelectBasic,
  IStyledSelectServiceRequests,
} from "../../core/types/types";

function StyledSelect({
  label,
  required = true,
  dropdownItems,
  serviceRequestDropdowns,
  onChange,
  defaultValue = "",
}: IStyledSelectBasic | IStyledSelectServiceRequests) {
  return (
    <div className="h-full w-full mb-4 flex flex-col">
      {/* <label htmlFor={label} className="subheading-font pb-2">
        {label}
      </label> */}
      <div className="shadow-sm rounded flex relative">
        <select
          name={label}
          required={required}
          id={label}
          onChange={onChange}
          title={label}
          defaultValue={defaultValue}
          className="pr-14 bg-white cursor-pointer appearance-none z-10 pl-3 text-base transition duration-300 ease-in-out placeholder-gray-500 text-gray-800 py-3 w-full border border-gray-300 shadow-sm focus:outline-none focus:border-gray-800 rounded"
        >
          <option disabled value="">
            {label}
          </option>
          {dropdownItems &&
            Object.entries(dropdownItems).map(
              ([itemKey, itemValue]: [string, string], index: number) => (
                <option value={itemKey} key={index}>
                  {itemValue}
                </option>
              )
            )}
          {serviceRequestDropdowns && (
            <>
              <optgroup label="Missed collection">
                {serviceRequestDropdowns
                  .filter((x) => x.category === "Missed collection")
                  .map((y) => (
                    <option key={y.id} value={y.id}>
                      {y.title}
                    </option>
                  ))}
              </optgroup>
              <optgroup label="Public bins">
                {serviceRequestDropdowns
                  .filter((x) => x.category === "Public bins")
                  .map((y) => (
                    <option key={y.id} value={y.id}>
                      {y.title}
                    </option>
                  ))}
              </optgroup>
              <optgroup label="Kerbside collections">
                {serviceRequestDropdowns
                  .filter((x) => x.category === "Kerbside collections")
                  .map((y) => (
                    <option key={y.id} value={y.id}>
                      {y.title}
                    </option>
                  ))}
              </optgroup>
              <optgroup label="Other">
                {serviceRequestDropdowns
                  .filter((x) => x.category === "Other")
                  .map((y) => (
                    <option key={y.id} value={y.id}>
                      {y.title}
                    </option>
                  ))}
              </optgroup>
            </>
          )}
        </select>
        <div
          className="px-4 flex items-center border-l border-gray-300 shadow-sm flex-col justify-center text-gray-500
    absolute right-0 bottom-0 top-0 mx-auto z-20 pointer-events-none"
        >
          <svg
            tabIndex={-1}
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-chevron-up"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <polyline points="6 15 12 9 18 15" />
          </svg>
          <svg
            tabIndex={-1}
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-chevron-down"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default StyledSelect;
